import { Injectable } from '@angular/core';
import { CallApiService } from 'src/app/shared/services/call-api.service';
import { EncrypterService } from 'src/app/shared/services/encrypter.service';
import * as constants from '../../shared/helpers/constants';

@Injectable({
  providedIn: 'root'
})
export class MyRequestsService {

  constructor(private _EncrypterService: EncrypterService,
    private _CallApiService: CallApiService,
  ) { }

  private getEmployeeRequestsWrapper_url: string = constants.getEmployeeRequestsWrapper_url;
  private getAvailableFormsWrapper_url: string = constants.getAvailableFormsWrapper_url;
  private get_formbuilder_url: string = constants.get_formbuilder_url;
  private save_preview_url: string = constants.save_preview_url;
  private get_form_list_url: string = constants.get_form_list_url;

  private get_pendingRequests_url = constants.get_pendingRequests_url;
  private update_workflowRequest_url = constants.update_workflowRequest_url;

  getEmployeeSelfRequests(Data: any) {
    return this._CallApiService.post_enc(Data, this.getEmployeeRequestsWrapper_url);
  }

  getAvailableForms(Data: any) {
    return this._CallApiService.post_enc(Data, this.getAvailableFormsWrapper_url);
  }

  getFormFields(Data: any) {
    return this._CallApiService.post_enc(Data, this.get_formbuilder_url);
  }

  savePreview(Data: any) {
    return this._CallApiService.post_enc(Data, this.save_preview_url);
  }

  getFormLists(Data: any) {
    return this._CallApiService.post_enc(Data, this.get_form_list_url);
  }

  getPendingWorkflowRequests(Data: any) {
    return this._CallApiService.post_enc(Data, this.get_pendingRequests_url);
  }

  updateWorkflowRequest(Data: any) {
    return this._CallApiService.post_enc(Data, this.update_workflowRequest_url);
  }

  private SaveJobPosting_url = constants.SaveJobPosting_url
  saveJobPosting(obj: any) {
    return this._CallApiService.post_enc(obj, this.SaveJobPosting_url);
  }
}
